<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row style="padding-top: 20px;">
        <el-form-item label="店铺名称" label-width="70px" label-position="left" class="fromItem" prop="shopName">
          <el-input v-model="serchParams.shopName" placeholder="请输入店铺名称"></el-input>
        </el-form-item>
        <el-form-item label="店铺编号" label-width="70px" label-position="left" class="fromItem" prop="shopNo">
          <el-input v-model="serchParams.shopNo" placeholder="请输入店铺编号"></el-input>
        </el-form-item>
        <el-form-item label="代理商规则" label-width="100px" label-position="left" class="fromItem" prop="infoWay">
          <el-select v-model="serchParams.infoWay" placeholder="请选择">
            <el-option
                v-for="item in infoWayList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

        </el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>
    <div class="d-flex">
      <el-button class="ma" type="primary" @click="handleAddOrder('add')">+添加店铺</el-button>
    </div>
    <commonTable
        :tableData="tableData"
        :total="total"
        :currentPage="pageNum"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:table>
        <el-table-column
            prop="shopName"
            align="center"
            label="店铺名称"
        >
        </el-table-column>
        <el-table-column
            prop="shopNo"
            align="center"
            label="店铺编号"
        >
        </el-table-column>
        <el-table-column
            prop="infoWay"
            align="center"
            label="代理商规则"
        >
          <template slot-scope="scope">
            {{scope.row.infoWay | infoWayFormat(infoWayList)}}
          </template>
        </el-table-column>
        <el-table-column
            prop="shopRemark"
            align="center"
            label="店铺备注"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
        />
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text"  @click="handleAddOrder('edit', scope.row)">编辑
            </el-button>
            <el-button type="text"  @click="delOrder(scope.row)" class="redBtn">删除
            </el-button>
          </template>
        </el-table-column>

        <el-dialog :title="title" :visible.sync="dialogFormVisible" append-to-body >
          <el-form :model="form" label-width="80px" :rules="rules" ref="shopForm">
            <el-form-item label="店铺名称" prop="shopName">
              <el-input v-model="form.shopName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="店铺编号" prop="shopNo">
              <el-input v-model="form.shopNo" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="代理商规则" prop="infoWay">
              <el-radio-group v-model="form.infoWay" v-for="(item,index) in infoWayList" :key="index">
                <el-radio :label="item.value">{{item.label}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="店铺备注">
              <el-input v-model="form.shopRemark" autocomplete="off" type="textarea"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveForm">确 定</el-button>
          </div>
        </el-dialog>

      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {selectShopList, addOrUpdateShop, delShop} from '@/api/crkShop.js'

export default {
  name: "crkShop",
  components: {
    commonTable,
  },
  data() {
    return {
      rules: {
        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
        ],
        shopNo: [
          { required: true, message: '请输入店铺编号', trigger: 'blur' },
        ],
        infoWay: [
          { required: true, message: '请选择档案规则', trigger: 'blur' },
        ],
      },
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      serchParams: {
        shopName:'',
        shopNo:'',
        infoWay:''
      },
      form:{
        id:'',
        shopName:'',
        shopNo:'',
        shopRemark:'',
        infoWay:1
      },
      title:'新增店铺',
      infoWayList: [
        {
          label: '按分销商为主体',
          value: 1,
        },
        {
          label: '按客服备注为主体',
          value: 2,
        },
        {
          label: '按客户网名为主体',
          value: 3,
        }
      ],
      dialogFormVisible:false
    };
  },
  filters: {
    infoWayFormat(value,list){
      let label = ''
      list.forEach(item=>{
        if(item.value == value){
          label = item.label
        }
      })
      return label
    }
  },
  created() {
    this.getList()
  },
  methods: {
    saveForm(){
      addOrUpdateShop(this.form).then(res=>{
        if(res.code == 200){
          this.$message.success('保存成功')
          this.dialogFormVisible = false
          this.getList()
        }
      })
    },
    detail(row) {

    },
    copy(context) {
      // 创建输入框元素
      let oInput = document.createElement('input');
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      // 弹出复制成功信息
      this.$message.success('复制成功');
      // 复制后移除输入框
      oInput.remove();
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddOrder(type, data) {
      this.resetForm()
      if ('edit'==type){
        this.form = JSON.parse(JSON.stringify(data))
      }
      this.dialogFormVisible = true
    },
    resetForm() {
      this.form.id = ''
      this.form.shopName = ''
      this.form.infoWay = 1
      this.form.shopNo = ''
      this.form.shopRemark = ''
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    resetSearch() {
      this.serchParams.shopName = ''
      this.serchParams.shopNo = ''
      this.serchParams.infoWay = ''
      this.pageNum = 1
      this.getList()
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      params = Object.assign(params, this.serchParams)
      selectShopList(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })

    },
    boxDetail(data) {
      this.$refs.boxDetail.init(data.id, this.wareStatus)
      this.$refs.boxDetail.dialogTableVisible = true
    },
    delOrder(row) {
      this.$confirm('此操作将永久删除该店铺, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delShop({id: row.id}).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getList()
          }
        })
      }).catch(() => {
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.name_status {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(63, 114, 246, 0.11);
  border: 1px solid #3F72F6;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3F72F6;
  text-align: center;
}

.name_status1 {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(243, 136, 46, 0.11);
  border: 1px solid #F3882E;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F3882E;
  text-align: center;
}

.copyTxt {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  color: #3F72F6;
}

.greenTag {
  color: #fff;
  background: #08A89B;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.greyTag {
  background: #e5e5e5;
  color: #333;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.redTag {
  background: #e5e5e5;
  color: #f00;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;
}

.redBtn, .redColor {
  color: #f00;
}
/deep/.el-cascader-node>.el-radio, .el-radio:last-child {
  margin-right: 30px;
}
</style>

